import Component from '../core/Component';

export default class SocialPopup extends Component {
    constructor(element) {
        super(element);
    }

    prepare() {
        if(window.innerWidth >= 767) {
            this.element.addEventListener('click', event => {
                event.preventDefault();
                window.open(this.element.getAttribute('href'), 'KPMG', 'width=558,height=553,menubar=no,resizable=yes,left=200,top=200');
            })
        }
    }
}


// WEBPACK FOOTER //
// ./components/SocialPopup.js